import { Box, Button, Container, Typography } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import appleStoreImage from "./assets/apple.png";
import playStoreImage from "./assets/play-store.png";
import logo from "./assets/logo.png";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
  },
});

function App() {
  const [extractedCode, setExtractedCode] = useState(null);

  useEffect(() => {
    // Extract code from URL path
    const path = window.location.pathname;
    const code = path.split("/").pop();

    // Check if the last part exists and is not empty
    if (code && code !== "" && code !== "/") {
      setExtractedCode(code);
    }
  }, []);

  const handleClick = async (platform) => {
    // if (!extractedCode) {
    //   return;
    // }

    try {
      // Create payload matching backend format
      const now = new Date();
      const timestamp = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}:${String(
        now.getHours()
      ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
        now.getSeconds()
      ).padStart(2, "0")}Z`;

      const payload = {
        timestamp: timestamp,
        code: extractedCode,
        platform: platform === "Play Store" ? "Android" : "iOS",
      };

      // Console log for debugging
      console.log(`Sending to API: ${JSON.stringify(payload)}`);

      // Send POST request to the API
      const response = await fetch("https://m.bro.ws/api/record", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (platform === "Play Store") {
        window.location.replace(
          "https://play.google.com/store/apps/details?id=com.snapitonline.snap_it&pcampaignid=web_share"
        );
      } else {
        window.location.replace(
          "https://apps.apple.com/lk/app/snapit-online/id6477333846"
        );
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="md">
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            gap: 3,
          }}
        >
          <Box>
            <img
              src={logo}
              alt="Company Logo"
              style={{
                width: "150px",
                height: "auto",
                maxWidth: "100%",
              }}
            />
            <Typography variant="h4" sx={{ fontWeight: 600 }}>
              Snapit
            </Typography>
          </Box>
               <Box
            sx={{
              display: "flex",
              gap: 2,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={() => handleClick("Play Store")}
              sx={{
                p: 0,
                minWidth: 0,
                borderRadius: 2,
              }}
            >
              <img
                src={playStoreImage}
                alt="Get it on Google Play"
                style={{
                  width: "200px",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </Button>
            <Button
              onClick={() => handleClick("Apple Store")}
              sx={{
                p: 0,
                minWidth: 0,
                borderRadius: 2,
              }}
            >
              <img
                src={appleStoreImage}
                alt="Download on the App Store"
                style={{
                  width: "200px",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </Button>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold" }}
            >{`SnapIt සමග සම්බන්ධ වන්න !`}</Typography>
            <Typography
              variant="body2"
              gutterBottom
            >{`බිල් ගෙවන එක වදයක් නේද ? ඉහත ලින්ක් එක හරහා SnapIt app එක download කර, ඔබගේ ප්‍රියතම වෙළඳ නාම සමඟ සම්බන්ධ වී, පරිත්යාග ලකුණු (reward points) එකතු කරන්න. මේ ලකුණු ඔබට කාඩ්පත්, වවුචර් වැනි දිරිමත් කිරීම් සඳහා පමණක් නොව, ඔබේ විදුලිය, ජලය, අන්තර්ජාලය වැනි උපයෝගිතා බිල් ගෙවීමටත් භාවිතා කළ හැක. ඉදිරියේදී තවත් වටිනා වෙළද සන්නාම බලාපොරොත්තු වන්න.`}</Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold" }}
            >{`SnapIt உடன் பரிசுகளைப் பெறுங்கள்!`}</Typography>
            <Typography
              variant="body2"
              gutterBottom
            >{`இப்போது அனைவரும் ஷாப்பிங் செய்யும் போது சம்பாதிக்கிறார்கள் — நீங்களும் தயாரா? இப்போதே SnapIt-ஐ பதிவிறக்கம் செய்து, உங்கள் விருப்பமான பிராண்டுகளுடன் இணைந்து உண்மையான பரிசுகளைப் பெறும் ஆயிரக்கணக்கானவர்களில் நீங்களும் ஒருவராகுங்கள்! உங்கள் பாயிண்டுகளை பயன்படுத்தி சிறப்பு சலுகைகள் பெறுங்கள் — அல்லது உங்கள் மின்சாரம், தண்ணீர், இன்டர்நெட் பில்களையும் எளிதாக செலுத்துங்கள்! இப்போதே தொடங்குங்கள் — ஷாப்பிங் செய், சம்பாதி, மகிழ்ந்து அனுபவி! மிக விரைவில் மேலும் அற்புதமான பிராண்டுகளும் சலுகைகளும் உங்களைச் சந்திக்க வரவிருக்கின்றன!`}</Typography>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold" }}
            >{`Stay rewarded with SnapIt !`}</Typography>
            <Typography
              variant="body2"
              gutterBottom
            >{`Everyone's earning while they shop !! are you? Download SnapIt and join thousands already turning their brand interactions into real rewards. Use your points for exclusive offers or even to pay your bills. Start now shop, earn, and enjoy the benefits. More amazing brands and offers are coming soon!`}</Typography>
          </Box>

     
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export default App;
